module.exports = __webpack_public_path__ + "static/img/1-2.1527519.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/1-2.jpg
// module id = 8iLM
// module chunks = 25